export const cookieConsentStyles = {
  cookieBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.3)",
    zIndex: 999,
  },
  cookieContainer: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    bottom: "16px",
    right: "16px",
    maxWidth: "380px",
    background: "#fff",
    borderRadius: "14px",
    padding: "20px",
    zIndex: 1000,
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    fontFamily: "inherit",
  },

  cookieTitle: {
    color: "#8C1614",
    fontSize: "16px",
    fontWeight: 600,
  },
  cookieText: {
    fontSize: "14px",
    color: "#555",
    marginTop: "8px",
    lineHeight: 1.4,
  },
  cookieLinks: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alingText: "center",
    fontSize: "14px",
    marginTop: "16px",
  },
  cookieLinksA: {
    color: "#8C1614",
    textDecoration: "underline",
  },
  cookieActions: {
    display: "flex",
    marginTop: "12px",
    justifyContent: "space-between",
    flexDirection: "column",
    fontSize: "16px",
    alignText: "center",
    // background: "#8C1614",
  },
  cookieLinkButton: {
    alignText: "center",
    justifyContent: "center",
    background: "none",
    border: "none",
    padding: 0,
    color: "#666",
    fontSize: "16px",
    cursor: "pointer",
    textDecoration: "underline",
    marginBottom: "10px",
  },
  cookieButtons: {
    display: "flex",
    gap: "8px",
    background: "#fff",
    justifyContent: "space-between",
  },
  cookieButton: {
    backgroundColor: "#8C1382",
    padding: "8px 14px",
    borderRadius: "8px",
    fontSize: "18px",
    border: "1px solid #ccc",
  },
  cookieButtonPrimary: {
    background: "#63A361",
    color: "#000",
    cursor: "pointer",
  },
  cookieButtonSecondary: {
    background: "#BF092F",
    color: "#000",
    cursor: "pointer",
  },
  cookieModalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.4)",
    zIndex: 1001,
  },
  cookieModal: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#fff",
    padding: "24px",
    borderRadius: "14px",
    maxWidth: "420px",
    width: "100%",
    zIndex: 1002,
  },
  cookieOption: {
    marginTop: "16px",
  },
  cookieOptionP: {
    fontSize: "12px",
    color: "#666",
    marginLeft: "22px",
  },
  cookieModalActions: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
};
